import React from 'react';
import './styles.scss';

const TicketSummary = ({ ticket }) => {
  const {
    id,
    doc_type,
    fieldMeets,
    standbys,
    pge_excavator,
    pge_work_date,
    pge_status,
    work_type,
    pge_division,
    pge_folder,
  } = ticket;

  const ticketDue = pge_work_date;
  const ticketDueFormatted = ticketDue
    ? new Date(parseInt(ticketDue)).toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles',
      })
    : 'Unscheduled';
  const trimmedId = doc_type === 'ticket' ? id.split('-')[0] : id;
  return (
    <div className="summary">
      <div className="summary-row">
        <SummaryDetails title={'ID'} content={trimmedId} />
        <SummaryDetails title={'Status'} content={pge_status} />
        <SummaryDetails title={'Division'} content={pge_division} />
        <SummaryDetails title={'Folder'} content={pge_folder} />
        <SummaryDetails title={'Work Type'} content={work_type} />
      </div>
      {ticket.type === 'RNEW' && ticket.pge_status === 'OPEN' && (
        <div className="detail-row">
          <span style={{ backgroundColor: '#FFFF00' }}>Please review work location</span>
        </div>
      )}
      <div className="summary-row">
        <SummaryDetails title={'Due Date & Time'} content={ticketDueFormatted} />
        <SummaryDetails title={'Excavator'} content={pge_excavator} />
        {fieldMeets?.length > 0 && <FMSBdetails title="Field Meets" content={fieldMeets} />}
        {standbys?.length > 0 && <FMSBdetails title="Standbys" content={standbys} />}
      </div>
    </div>
  );
};

export default TicketSummary;

const SummaryDetails = props => {
  const { title, content } = props;
  return (
    <div className="summary-detail">
      <div className="summary-title">{title}</div>
      <div className="summary-content">{content}</div>
    </div>
  );
};

const FMSBdetails = props => {
  const { title, content } = props;
  return (
    <div className="summary-detail">
      <div className="summary-title">{title}</div>
      <div className="summary-content" style={{ display: 'grid' }}>
        {content.map(item => (
          <a href={`${process.env.REACT_APP_BASE_PATH}/ticketdetails/${item.id}`} key={item.id}>
            {item.id}
          </a>
        ))}
      </div>
    </div>
  );
};
